import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Heading,
  Box,
  ModalContentProps,
  Stack
} from '@chakra-ui/core'
import React from 'react'
import { capitalize } from 'lodash'
import { FcCheckmark, FcDisclaimer, FcFullTrash } from 'react-icons/fc'
import { SecondaryButton, PrimaryButton } from '../Buttons'

export type AlertModalProps = {
  isOpen: boolean
  activatorStatus?: 'activate' | 'deactivate' | 'warning'
  onClose: () => void
  loading?: boolean
  onConfirm: (id?: string) => Promise<void> | void
  confirmButtonText?: string
  confirmButtonColor?: string
  title?: string
  icon?: React.ReactNode
  noCancel?: boolean
} & ModalContentProps

const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  loading,
  activatorStatus,
  title,
  confirmButtonText,
  confirmButtonColor,
  children,
  icon,
  noCancel,
  ...rest
}) => {
  const isActive = activatorStatus === 'activate'
  return (
    <Modal isCentered onClose={onClose} isOpen={isOpen} size="xs" {...rest}>
      <ModalOverlay />
      <ModalContent borderRadius="md" {...rest}>
        <ModalBody fontSize="sm">
          <Stack mt={8}>
            <Box pb={6}>
              {icon ? (
                icon
              ) : isActive ? (
                <FcCheckmark size={38} />
              ) : activatorStatus === 'warning' ? (
                <FcDisclaimer size={38} />
              ) : (
                <FcFullTrash size={38} />
              )}
            </Box>
            <Box color="gray.500" fontSize="xs">
              <Heading size="sm" mb={2} fontWeight={500} color="gray.800" as="h2">
                {title}
              </Heading>
              {children}
            </Box>
          </Stack>
        </ModalBody>

        <ModalFooter>
          {!noCancel && (
            <SecondaryButton flex={1} mr={3} onClick={onClose}>
              Cancel
            </SecondaryButton>
          )}
          <PrimaryButton
            flex={1}
            isLoading={loading}
            onClick={() => onConfirm()}
            variantColor={
              confirmButtonColor
                ? confirmButtonColor
                : activatorStatus === 'activate'
                ? 'green'
                : activatorStatus === 'warning'
                ? 'yellow'
                : 'red'
            }
          >
            {confirmButtonText
              ? confirmButtonText
              : activatorStatus
              ? capitalize(activatorStatus)
              : 'Delete'}
          </PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

AlertModal.defaultProps = {
  title: 'Delete'
}

export default AlertModal
